import { env } from '@/../config'

export default {
  /**Отходообразователи */
  emitter: {
    id: 'emitter',
    groupLayer: false,
    type: 'emitter',
    coloringType: 'emitter',
    styleId: 'emitter',
    dataSource: 'emitter',
    name: 'Отходообразователи',
    order: 100,
    visibility: false, // видимость в основном окне объектов
    zoneVisibility: false, // видимость слоя в режиме редактирования зон
    open: false,
    canToggleItemsVisibility: false, // можно ли изменить видимость одного объекта
    scrollable: true, //подгрузка дополнительных объектов при скролле
    hide: false, // скрыть панель полностью
    icon: {
      type: 'circle',
      background: '#db3283'
    },
    mapIcon: {
      type: 'circle',
      background: '#db3283'
    },
    layerLoadEntity: 'emitters',
    labels: {
      collapseButton: 'Закрыть список отходообразователей',
      expandButton: 'Открыть список отходообразователей'
    }
  },

  /**Контейнерные площадки */
  containerplatform: {
    id: 'containerplatform',
    groupLayer: false,
    type: 'containerplatform',
    styleId: 'containerplatform',
    dataSource: 'containerplatform',
    name: 'Контейнерные площадки',
    order: 700,
    hide: false,
    visibility: false,
    zoneVisibility: false,
    open: false,
    scrollable: true,
    canToggleItemsVisibility: false,
    layerItemComponent: 'ContainerPlatformAddress',
    icon: {
      type: 'circle',
      background: '#56CCF2'
    },
    mapIcon: {
      type: 'circle',
      background: '#56CCF2'
    },
    fields: 'id,address,containers',

    layerLoadEntity: 'containerplatform',

    labels: {
      collapseButton: 'Закрыть список контейнерных площадок',
      expandButton: 'Открыть список контейнерных площадок'
    },

    //Показать в панели условных обозначений справа
    showInMapLayerLegend: true
  },

  /**Территориальное деление */
  zonegroup: {
    id: 'zonegroup',
    groupLayer: true,
    name: 'Территориальное деление',
    order: 1500,
    visibility: true,
    zoneVisibility: true,
    showChildLayerCount: true, //показать количество дочерних слоев
    showLabels: false, // настройка отображения лейбла (названия территорий на карте)
    labelsMinZoom: null, // Минимальный зум на котором отображаются подписи
    hidePublicTransport: false, // скрыть зоны ро для публичных ws (использовалось на хмао)
    open: false,
    canToggleItemsVisibility: false,
    childrenDraggable: false,
    singleChildVisibility: true,
    /**
     * Укажем выбранную раскраску по умолчанию для папки "Территориальное деление",
     * эта раскраска применится к группе зон по умолчанию (default: true)
     * Обычно это группа зон "Административное деление"
     */
    selectedColor: 'trip_mass',

    hideChangingAttributes: false,

    /**Фильтровать содержимое на клиенте с помощью строки "Быстрый поиск" */
    filterByText: true,

    labels: {
      collapseButton: 'Закрыть список групп зон',
      expandButton: 'Открыть список групп зон',
      showMapLabels: 'Отобразить названия территорий на карте',
      hideMapLabels: 'Скрыть названия территорий на карте'
    }
  },

  /**Направления вывоза */
  exportDirections: {
    id: 'exportDirections',
    groupLayer: true,
    name: 'Направления вывоза',
    order: 400,
    visibility: true,
    zoneVisibility: false,
    open: false,
    canToggleItemsVisibility: false,
    transportTypeButton: false,
    labels: {
      collapseButton: 'Закрыть группу слоев “Направления вывоза”',
      expandButton: 'Открыть группу слоев “Направления вывоза”',
      transportTypeButton: 'Открыть окно выбора типа транспорта'
    }
  },

  /**Маршруты */
  route: {
    id: 'route',
    groupLayer: true,
    name: 'Маршруты',
    order: 300,
    visibility: true,
    zoneVisibility: true,
    open: false,
    /**При клике на линию чувствительность в пикселях */
    tolerance: 5,
    carTypesButton: true,
    labels: {
      collapseButton: 'Закрыть список маршрутов',
      expandButton: 'Открыть список маршрутов'
    }
  },

  /**Информационные слои*/
  info: {
    id: 'info',
    groupLayer: true,
    //type: 'info',
    name: 'Информационные слои',
    order: 500,
    visibility: true,
    zoneVisibility: false,
    open: false,
    canToggleItemsVisibility: false,
    showChildLayerCount: true,
    labels: {
      collapseButton: 'Закрыть список информационных слоев',
      expandButton: 'Открыть список информационных слоев'
    }
  },

  /**Линейные информационные слои */
  streaminfo: {
    id: 'streaminfo',
    groupLayer: true,
    type: 'group',
    name: 'Линейные информационные слои',
    order: 600,
    visibility: true,
    zoneVisibility: false,
    open: false,
    canToggleItemsVisibility: true,
    showChildLayerCount: true,
    /**При клике на линию чувствительность в пикселях */
    tolerance: 5,
    labels: {
      collapseButton: 'Закрыть список линейных информационных слоев',
      expandButton: 'Открыть список линейных информационных слоев'
    }
  },

  /**Петли сбора */
  collectingloop: {
    id: 'collectingloop',
    parentId: 'route',
    groupLayer: false,
    name: 'Петли сбора',
    order: 100,
    visibility: false,
    zoneVisibility: false,
    scrollable: true,
    open: false,
    canToggleItemsVisibility: true,

    /**Поля которые надо запросить у серевера при запросе объектов. По умолчанию 'id,name'*/
    fields: 'id,route',

    /**При клике на линию чувствительность в пикселях */
    tolerance: 5,

    layerLoadEntity: 'round',

    mwParams: ['treatment_type'],

    labels: {
      collapseButton: 'Закрыть список петель сбора',
      expandButton: 'Открыть список петель сбора'
    },
    type: 'vectorTile',
    styleId: 'collectingLoopMVT',
    selectedStyleId: 'collectingLoopMVTSelected',
    dataSource: 'collectingLoopMVT',
    url: 'api/mvt/collecting_loop/?x={x}&y={y}&zoom={z}',

    detailInfoType: 'collectingloop',
    tooltipSettings: {
      minWidth: 280,
      offset: { x: 0, y: 0 },
      autoPan: false,
      closeButton: false,
      className: 'Popup--toBottom'
    },
    tooltipTemplate:
      '<div class="LeafletPopup-main LeafletRouterPopup"><div class="LeafletPopup-title">Петля сбора</div><div><b>№ ${properties.id}</b></div></div>',
    multipleTooltipTemplate:
      '<div class="LeafletPopup-main LeafletRouterPopup"><div class="LeafletPopup-title">Петли сбора: ${propertiesArray.length}шт.</div></div>'
  },

  /**Маршруты перевозки */
  transfer: {
    id: 'transfer',
    parentId: 'route',
    groupLayer: false,
    type: 'vectorTile',
    coloringType: 'transfer',
    styleId: 'transferMVT',
    selectedStyleId: 'transferMVTSelected',
    dataSource: 'transferMVT',
    name: 'Маршруты перевозки',
    order: 200,
    visibility: false,
    zoneVisibility: false,
    scrollable: true,
    open: false,
    canToggleItemsVisibility: true,

    /**Поля которые надо запросить у серевера при запросе объектов. По умолчанию 'id,name'*/
    fields: 'id,route',

    /**При клике на линию чувствительность в пикселях */
    tolerance: 5,

    layerLoadEntity: 'cruise',

    mwParams: ['treatment_type'],

    labels: {
      collapseButton: 'Закрыть список маршрутов перевозки',
      expandButton: 'Открыть список маршрутов перевозки'
    },

    url: 'api/mvt/transfer/?x={x}&y={y}&zoom={z}&fields=id,tkm',
    alwaysShowInPanel: false,
    detailInfoType: 'transfer',
    tooltipSettings: {
      minWidth: 280,
      offset: { x: 0, y: 0 },
      autoPan: false,
      closeButton: false,
      className: 'Popup--toBottom'
    },
    tooltipTemplate: `<div class="LeafletPopup-main LeafletRouterPopup">
      <div class="LeafletPopup-title">Маршрут перевозки</div>
      <div><b>№ \${properties.id}</b>
      </div></div>`,
    multipleTooltipTemplate: `<div class="LeafletPopup-main LeafletRouterPopup">
      <div class="LeafletPopup-title">Маршруты перевозки: \${propertiesArray.length}шт.</div>
      </div>`
  },

  /**Маршруты вывоза */
  removaltrip: {
    id: 'removaltrip',
    parentId: 'route',
    groupLayer: false,
    name: 'Маршруты вывоза',
    order: 300,
    visibility: false,
    zoneVisibility: false,
    open: false,
    scrollable: true,
    canToggleItemsVisibility: true,

    /**Поля которые надо запросить у серевера при запросе объектов. По умолчанию 'id,name'*/
    fields: 'id,color,route',

    /**При клике на линию чувствительность в пикселях */
    tolerance: 5,

    layerLoadEntity: 'trip',

    mwParams: ['treatment_type'],

    labels: {
      collapseButton: 'Закрыть список маршрутов вывоза',
      expandButton: 'Открыть список маршрутов вывоза'
    },
    type: 'vectorTile',
    styleId: 'removalTripMVT',
    selectedStyleId: 'removalTripMVTSelected',
    dataSource: 'removalTripMVT',
    url: 'api/mvt/removal_trip/?x={x}&y={y}&zoom={z}',
    detailInfoType: 'removaltrip',
    tooltipSettings: {
      minWidth: 280,
      offset: { x: 0, y: 0 },
      autoPan: false,
      closeButton: false,
      className: 'Popup--toBottom'
    },
    tooltipTemplate:
      '<div class="LeafletPopup-main LeafletRouterPopup"><div class="LeafletPopup-title">Маршрут вывоза</div><div><b>№ ${properties.id}</b></div></div>',
    multipleTooltipTemplate: `<div class="LeafletPopup-main LeafletRouterPopup">
        <div class="LeafletPopup-title">Маршруты вывоза: \${propertiesArray.length}шт.</div>
        </div>`
  },

  /**Потоки отходов */
  flow: {
    id: 'flow',
    parentId: 'exportDirections',
    groupLayer: false,
    type: 'flow',
    styleId: 'flow',
    dataSource: 'flow',

    coloringType: 'flow',

    name: 'Потоки отходов',
    order: 100,
    visibility: true,
    zoneVisibility: false,
    open: false,
    scrollable: true,
    canToggleItemsVisibility: false,
    selectedProblems: null, // показать только потоки, у которых есть выбранные проблемы
    selectedTransportTypes: null, //Показать только потоки по выбранному типу транспорта (ОПВК)
    selectedLevel: [1, 2], // уровень потоков
    showItems: env.VUE_APP_FLOW_ANIMATION, // показывать предметы на потоке
    animation: env.VUE_APP_FLOW_SHOW_ITEMS, // анимировать потоки
    iconClass: 'IconLayerFlow',
    icon: {
      type: 'img'
    },

    /**Поля которые надо запросить у серевера при запросе объектов. По умолчанию 'id,name'*/
    fields: 'id,destination,source_infrastructure,infrastructure,source,level',

    /**При клике на линию чувствительность в пикселях */
    tolerance: 5,

    /**Всегда отображать слой в панели слева */
    alwaysShowInPanel: true,

    labels: {
      collapseButton: 'Закрыть список потоков отходов',
      expandButton: 'Открыть список потоков отходов'
    },

    //Показать в панели условных обозначений справа
    showInMapLayerLegend: true,

    //Скрыть предметы в подсказке потока
    hideItemsInPopup: false,
    //Скрыть проблемы в подсказке потока
    hideProblemsInPopup: false
  },

  /**Источники потоков */
  source: {
    id: 'source',
    parentId: 'exportDirections',
    groupLayer: false,
    type: 'source',
    styleId: 'source',
    dataSource: 'source',
    name: 'Источники потоков',
    order: 200,
    visibility: true,
    zoneVisibility: false,
    open: false,
    scrollable: true,
    canToggleItemsVisibility: false,
    iconClass: 'IconLayerSource',
    icon: {
      type: 'img'
    },
    mapIcon: {
      type: 'smallCircle',
      color: '#0288F3'
    },
    labels: {
      collapseButton: 'Закрыть список источников потоков',
      expandButton: 'Открыть список источников потоков'
    }
  },

  /**Транспортные базы */
  transportbase: {
    id: 'transportbase',
    type: 'transportbase',
    groupLayer: false,
    styleId: 'transportbase',
    dataSource: 'transportbase',
    name: 'Транспортные базы',
    order: 250,
    visibility: true,
    zoneVisibility: false,
    open: false,
    scrollable: true,
    canToggleItemsVisibility: false,
    icon: {
      type: 'dataSrc',
      dataSrc: require('@/assets/transportBase.svg')
    },
    mapIcon: {
      type: 'icon'
    },

    layerLoadEntity: 'transportbase',

    labels: {
      collapseButton: 'Закрыть список транспортных баз',
      expandButton: 'Открыть список транспортных баз'
    }
  },

  /**Здания */
  building: {
    id: 'building',
    groupLayer: false,
    type: 'building',
    name: 'Здания',
    styleId: 'building',
    dataSource: 'building',
    order: 1100,
    visibility: false,
    zoneVisibility: false,
    open: false,
    scrollable: true,
    canToggleItemsVisibility: false,
    icon: {
      type: 'circle',
      background: '#33d85e'
    },
    mapIcon: {
      type: 'circle',
      background: '#33d85e'
    },

    layerLoadEntity: 'building',

    labels: {
      collapseButton: 'Закрыть список зданий',
      expandButton: 'Открыть список зданий'
    }
  },

  /**Объекты инфраструктуры */
  infrastructure: {
    id: 'infrastructure',
    groupLayer: true,
    type: 'infrastructure',
    dataSource: 'infrastructure',
    coloringType: 'infrastructure',
    name: 'Объекты инфраструктуры',
    order: 200,
    visibility: true,
    zoneVisibility: false,
    open: false,
    canToggleItemsVisibility: true,
    childrenDraggable: false,
    scrollable: false,
    showChildLayerObjectsCount: true, //Отобразить суммарное количество объектов дочерних слоев

    /**В слой можно добавлять объекты */
    canAdd: true,
    /**Мутация, которую надо вызвать при нажатии кнопки добавления */
    addMutation: 'setInfrastructureEdit',
    /**Объект с параметрами мутации */
    addMutationPayload: {},

    selectedColor: 'trip_mass',

    hideChangingAttributes: false,
    hideTreatmentsInPopup: false,

    openAllClusters: false,
    toggleAllClustersButton: true,

    labels: {
      collapseButton: 'Закрыть список объектов инфраструктуры',
      expandButton: 'Открыть список объектов инфраструктуры',
      addButton: 'Добавить объект инфраструктуры',
      hideButton: 'Скрыть',
      showButton: 'Отобразить',
      expandAllClusters: 'Раскрыть все объекты с одинаковыми координатами',
      collapseAllClusters: 'Свернуть все объекты с одинаковыми координатами'
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/objects/defaultLayerSettings.js